(() => {
  // Drawer öffnen - versucht mehrere Theme-Varianten
  function openCartDrawer() {
    // Dawn / viele Themes
    const drawer = document.querySelector("cart-drawer");
    if (drawer && typeof drawer.open === "function") {
      drawer.open();
      return true;
    }

    // Buttons/Trigger
    const trigger =
      document.querySelector('[aria-controls="cart-drawer"]') ||
      document.querySelector('a[href="/cart"]') ||
      document.querySelector('button[name="open-cart"]');

    if (trigger) {
      trigger.click();
      return true;
    }

    // Fallback: cart page
    window.location.href = "/cart";
    return false;
  }

  // Prüft, ob cart item_count hochging
  async function getCartCount() {
    try {
      const r = await fetch("/cart.js", { credentials: "same-origin" });
      const cart = await r.json();
      return cart.item_count || 0;
    } catch {
      return null;
    }
  }

  async function waitForIncrease(start, timeoutMs = 4000) {
    const startTime = Date.now();
    while (Date.now() - startTime < timeoutMs) {
      const c = await getCartCount();
      if (typeof c === "number" && c > start) return true;
      await new Promise((res) => setTimeout(res, 150));
    }
    return false;
  }

  let busy = false;

  async function afterAddToCart() {
    if (busy) return;
    busy = true;

    const start = await getCartCount();
    if (start === null) {
      busy = false;
      return;
    }

    const ok = await waitForIncrease(start, 5000);
    if (ok) setTimeout(openCartDrawer, 250);

    busy = false;
  }

  // submit abfangen
  document.addEventListener(
    "submit",
    (e) => {
      const form = e.target;
      if (!form || !form.action) return;
      if (form.action.includes("/cart/add")) {
        setTimeout(afterAddToCart, 150);
      }
    },
    true
  );

  // click fallback
  document.addEventListener(
    "click",
    (e) => {
      const btn = e.target.closest('button[type="submit"], input[type="submit"]');
      if (!btn) return;

      const form = btn.closest("form");
      if (!form || !form.action) return;

      if (form.action.includes("/cart/add")) {
        setTimeout(afterAddToCart, 150);
      }
    },
    true
  );
})();
